module.exports = __webpack_public_path__ + "static/media/skywire.ebbe8e59.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/Skywire/skywire.svg
// module id = 1133
// module chunks = 0